// // **1. 共通データ型を定義**
// interface CategoryItem {
//   Kbn: number;
//   KbnName: string;
// }

// // **2. ジェネリッククラスを定義**
// class Category<T extends CategoryItem> {
//   private items: T[];

//   constructor(items: T[]) {
//     this.items = items;
//   }

//   // **3. KbnからKbnNameを取得**
//   getNameByKbn(kbn: number): string {
//     const item = this.items.find((item) => item.Kbn === kbn);
//     return item ? item.KbnName : "";
//   }

//   // **4. 全ての項目を取得**
//   getAll(): T[] {
//     return this.items;
//   }
// }

class MyCategory {
  CommonKbn = [
    { Kbn: 1, KbnName: "有" },
    { Kbn: 0, KbnName: "無" },
  ];

  CommonKbn2 = [
    { Kbn: 0, KbnName: "無" },
    { Kbn: 1, KbnName: "有" },
  ];

  YesNoKbn = [
    { Kbn: 1, KbnName: "はい" },
    { Kbn: 0, KbnName: "いいえ" },
  ];

  YesNoKbn2 = [
    { Kbn: 0, KbnName: "いいえ" },
    { Kbn: 1, KbnName: "はい" },
  ];

  FormKbn = [
    { Kbn: 1, KbnName: "マスター" },
    { Kbn: 2, KbnName: "随時処理" },
    { Kbn: 3, KbnName: "その他" },
    { Kbn: 4, KbnName: "請求処理" },
    { Kbn: 5, KbnName: "在庫処理" },
    { Kbn: 6, KbnName: "一覧" },
    { Kbn: 7, KbnName: "訪問看護医療請求" },
  ];

  Kaigo = [
    { Kbn: 0, KbnName: "", KaigoKbn: "0", CareType: "46" },
    { Kbn: 1, KbnName: "非該当", KaigoKbn: "0", CareType: "46" },
    { Kbn: 12, KbnName: "要支援１", KaigoKbn: "1", CareType: "46" },
    { Kbn: 13, KbnName: "要支援２", KaigoKbn: "1", CareType: "46" },
    { Kbn: 6, KbnName: "事業対象者", KaigoKbn: "2", CareType: "46" },
    { Kbn: 21, KbnName: "要介護１", KaigoKbn: "3", CareType: "43" },
    { Kbn: 22, KbnName: "要介護２", KaigoKbn: "3", CareType: "43" },
    { Kbn: 23, KbnName: "要介護３", KaigoKbn: "3", CareType: "43" },
    { Kbn: 24, KbnName: "要介護４", KaigoKbn: "3", CareType: "43" },
    { Kbn: 25, KbnName: "要介護５", KaigoKbn: "3", CareType: "43" },
  ];

  KaigoKbn = [
    { Kbn: "01", KbnName: "非該当" },
    { Kbn: "12", KbnName: "要支援１" },
    { Kbn: "13", KbnName: "要支援２" },
    { Kbn: "06", KbnName: "事業対象者" },
    { Kbn: "21", KbnName: "要介護１" },
    { Kbn: "22", KbnName: "要介護２" },
    { Kbn: "23", KbnName: "要介護３" },
    { Kbn: "24", KbnName: "要介護４" },
    { Kbn: "25", KbnName: "要介護５" },
  ];

  // 設定変えない(HokenKbn≠KohiKbn)
  KohiKbn = [
    { Kbn: 0, KbnName: "介護" },
    { Kbn: 1, KbnName: "医療" },
  ];

  DoctorShijiKbn = [
    { Kbn: 0, KbnName: "一般" },
    { Kbn: 1, KbnName: "特別" },
  ];

  FemaleKbn = [
    { Kbn: 1, KbnName: "男性" },
    { Kbn: 2, KbnName: "女性" },
  ];

  KyufuseigenKbn = [
    { Kbn: 0, KbnName: "制限無" },
    { Kbn: 1, KbnName: "制限有" },
  ];

  NinteiKbn = [
    { Kbn: 1, KbnName: "申請中" },
    { Kbn: 2, KbnName: "認定済" },
  ];

  GoseiKbn = [
    { Kbn: 0, KbnName: "すべて" },
    { Kbn: 1, KbnName: "基本" },
    { Kbn: 3, KbnName: "加算" },
  ];

  HiwariKbn = [
    { Kbn: 0, KbnName: "" },
    { Kbn: 1, KbnName: "日割" },
  ];

  KoyoKeitai = [
    //{ Kbn: 0, KbnName: "" },
    { Kbn: 1, KbnName: "正職員" },
    { Kbn: 2, KbnName: "契約職員" },
    { Kbn: 3, KbnName: "パート" },
    { Kbn: 4, KbnName: "アルバイト" },
    { Kbn: 5, KbnName: "その他" },
  ];

  CareplanKbn = [
    { Kbn: 0, KbnName: "週間" },
    { Kbn: 1, KbnName: "月間" },
  ];

  MemoKbn = [
    { Kbn: 0, KbnName: "通常" },
    { Kbn: 1, KbnName: "緊急" },
    { Kbn: 2, KbnName: "重要" },
    { Kbn: 3, KbnName: "最重要" },
  ];

  Netakirido = [
    { Kbn: "自立", KbnName: "自立", Index: 1 },
    { Kbn: "J1", KbnName: "J1", Index: 2 },
    { Kbn: "J2", KbnName: "J2", Index: 3 },
    { Kbn: "A1", KbnName: "A1", Index: 4 },
    { Kbn: "A2", KbnName: "A2", Index: 5 },
    { Kbn: "B1", KbnName: "B1", Index: 6 },
    { Kbn: "B2", KbnName: "B2", Index: 7 },
    { Kbn: "C1", KbnName: "C1", Index: 8 },
    { Kbn: "C2", KbnName: "C2", Index: 9 },
  ];

  Ninteido = [
    { Kbn: "自立", KbnName: "自立", Index: 1 },
    { Kbn: "Ⅰ", KbnName: "Ⅰ", Index: 2 },
    { Kbn: "Ⅱａ", KbnName: "Ⅱａ", Index: 3 },
    { Kbn: "Ⅱｂ", KbnName: "Ⅱｂ", Index: 4 },
    { Kbn: "Ⅲａ", KbnName: "Ⅲａ", Index: 5 },
    { Kbn: "Ⅲｂ", KbnName: "Ⅲｂ", Index: 6 },
    { Kbn: "Ⅳ", KbnName: "Ⅳ", Index: 7 },
    { Kbn: "M", KbnName: "M", Index: 8 },
  ];

  // 設定変えない(HokenKbn≠KohiKbn)
  HokenKbn = [
    { Kbn: 0, KbnName: "介護" },
    { Kbn: 1, KbnName: "医療" },
  ];

  ADL_Shokuji = [
    { Value: 10, KbnName: "自立", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_IJyo = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "一部介助(監視下)", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助(座れるが移れない)", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_Seiyo = [
    { Value: 5, KbnName: "自立", Index: 3, LifeIndex: 2 },
    { Value: 0, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_ToireDousa = [
    { Value: 10, KbnName: "自立", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_Nyuyoku = [
    { Value: 5, KbnName: "自立", Index: 3, LifeIndex: 2 },
    { Value: 0, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_HeichiHokou = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "一部介助(歩行器等)", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助(車椅子操作が可能)", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_KaidanSyoko = [
    { Value: 10, KbnName: "自立", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_Koui = [
    { Value: 10, KbnName: "自立", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_Haiben = [
    { Value: 10, KbnName: "自立", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_Hainyo = [
    { Value: 10, KbnName: "自立", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  ADL_ISHISOTSU = [
    { Value: 10, KbnName: "自立", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  IADL_CHORI = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "見守り", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  IADL_SENTAKU = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "見守り", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  IADL_SOUJI = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "見守り", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  KIKYO_NEGAERI = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "見守り", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  KIKYO_OKIAGARI = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "見守り", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  KIKYO_ZAI = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "見守り", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  KIKYO_TACHIAGARI = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "見守り", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  KIKYO_RITUI = [
    { Value: 15, KbnName: "自立", Index: 4, LifeIndex: 3 },
    { Value: 10, KbnName: "見守り", Index: 3, LifeIndex: 2 },
    { Value: 5, KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { Value: 0, KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  Jissido = [
    { Kbn: 1, KbnName: "実施" },
    { Kbn: 2, KbnName: "一部" },
    { Kbn: 3, KbnName: "未実施" },
  ];

  Tasseido = [
    { Kbn: 1, KbnName: "達成" },
    { Kbn: 2, KbnName: "一部" },
    { Kbn: 3, KbnName: "未達" },
  ];

  KyomiKansindo = [
    { Kbn: 3, KbnName: "している" },
    { Kbn: 2, KbnName: "してみたい" },
    { Kbn: 1, KbnName: "興味がある" },
  ];

  DBD13 = [
    { Kbn: 0, KbnName: "まったくない" },
    { Kbn: 1, KbnName: "ほとんどない" },
    { Kbn: 2, KbnName: "ときどきある" },
    { Kbn: 3, KbnName: "よくある" },
    { Kbn: 4, KbnName: "常にある" },
  ];

  HUKUYAKU_KANRI = [
    { KbnName: "自立", Index: 4, LifeIndex: 3 },
    { KbnName: "見守り", Index: 3, LifeIndex: 2 },
    { KbnName: "一部介助", Index: 2, LifeIndex: 1 },
    { KbnName: "全介助", Index: 1, LifeIndex: 0 },
  ];

  RIHA_IADL_HYOUKA1 = [
    { Value: 0, KbnName: "していない", Index: 1, LifeIndex: 0 },
    { Value: 5, KbnName: "まれにしている", Index: 2, LifeIndex: 1 },
    { Value: 10, KbnName: "週に１～２回", Index: 3, LifeIndex: 2 },
    { Value: 15, KbnName: "週に３回以上", Index: 4, LifeIndex: 3 },
  ];

  RIHA_IADL_HYOUKA2 = [
    { Value: 0, KbnName: "していない", Index: 1, LifeIndex: 0 },
    { Value: 5, KbnName: "まれにしている", Index: 2, LifeIndex: 1 },
    { Value: 10, KbnName: "週に１回未満", Index: 3, LifeIndex: 2 },
    { Value: 15, KbnName: "週に１回以上", Index: 4, LifeIndex: 3 },
  ];

  RIHA_IADL_HYOUKA3 = [
    { Value: 0, KbnName: "していない", Index: 1, LifeIndex: 0 },
    { Value: 5, KbnName: "時々", Index: 2, LifeIndex: 1 },
    { Value: 10, KbnName: "定期的にしている", Index: 3, LifeIndex: 2 },
    { Value: 15, KbnName: "植替等もしている", Index: 4, LifeIndex: 3 },
  ];

  RIHA_IADL_HYOUKA4 = [
    { Value: 0, KbnName: "0:していない", Index: 1, LifeIndex: 0 },
    { Value: 5, KbnName: "1:電球の取替、ねじ止め等", Index: 2, LifeIndex: 1 },
    {
      Value: 10,
      KbnName: "2:ペンキ塗り、模様替え、洗車",
      Index: 3,
      LifeIndex: 2,
    },
    {
      Value: 15,
      KbnName: "3:２に加え、家の修理、車の整備",
      Index: 4,
      LifeIndex: 3,
    },
  ];

  RIHA_IADL_HYOUKA5 = [
    { Value: 0, KbnName: "読んでいない", Index: 1, LifeIndex: 0 },
    { Value: 5, KbnName: "まれに", Index: 2, LifeIndex: 1 },
    { Value: 10, KbnName: "月１回程", Index: 3, LifeIndex: 2 },
    { Value: 15, KbnName: "月２回以上", Index: 4, LifeIndex: 3 },
  ];

  RIHA_IADL_HYOUKA6 = [
    { Value: 0, KbnName: "していない", Index: 1, LifeIndex: 0 },
    { Value: 5, KbnName: "週１～９時間", Index: 2, LifeIndex: 1 },
    { Value: 10, KbnName: "週10～29時間", Index: 3, LifeIndex: 2 },
    { Value: 15, KbnName: "週30時間以上", Index: 4, LifeIndex: 3 },
  ];

  RIHA_KEIKAKU_DOCTOR_KENSYU = [
    { Kbn: 1, KbnName: "修了済" },
    { Kbn: 2, KbnName: "受講途中" },
    { Kbn: 3, KbnName: "未受講" },
  ];

  WORK_FLOW_STAUS = [
    { Kbn: 1, KbnName: "保留" },
    { Kbn: 2, KbnName: "申請中" },
    { Kbn: 3, KbnName: "承認" },
    { Kbn: 4, KbnName: "否認" },
  ];

  SougeiKbn = [
    { Kbn: 1, KbnName: "迎え" },
    { Kbn: 2, KbnName: "送り" },
  ];

  SougeiBinNo = [
    { Kbn: 1, KbnName: "１便" },
    { Kbn: 2, KbnName: "２便" },
    { Kbn: 3, KbnName: "３便" },
    { Kbn: 4, KbnName: "４便" },
    { Kbn: 5, KbnName: "５便" },
    { Kbn: 6, KbnName: "６便" },
    { Kbn: 7, KbnName: "７便" },
    { Kbn: 8, KbnName: "８便" },
  ];

  TeiEiyoRiskLevel = [
    { Kbn: 1, KbnName: "低" },
    { Kbn: 2, KbnName: "中" },
    { Kbn: 3, KbnName: "高" },
  ];

  process = [
    { Kbn: 1, KbnName: "スクリーニング" },
    { Kbn: 2, KbnName: "アセスメント" },
    { Kbn: 3, KbnName: "モニタリング" },
  ];

  EiyoHokyuKeikoKbn = [
    { Kbn: 0, KbnName: "無" },
    { Kbn: 1, KbnName: "経口のみ" },
    { Kbn: 2, KbnName: "一部経口" },
  ];

  EiyoHokyuKeikoKbn2 = [
    { Kbn: 1, KbnName: "経腸栄養" },
    { Kbn: 2, KbnName: "静脈栄養" },
  ];

  ShokujiKeitai = [
    { Kbn: "50", KbnName: "50：常食" },
    { Kbn: "40", KbnName: "40：4_嚥下調整食4" },
    { Kbn: "30", KbnName: "30：3_嚥下調整食3" },
    { Kbn: "22", KbnName: "22：2-2_嚥下調整食2-2" },
    { Kbn: "21", KbnName: "21：2-1_嚥下調整食2-1" },
    { Kbn: "10", KbnName: "10：1j_嚥下調整食1j" },
    { Kbn: "02", KbnName: "02：0t_嚥下訓練食品0t" },
    { Kbn: "01", KbnName: "01：0j_嚥下訓練食品0j" },
  ];

  ToromiKbn = [
    { Kbn: 1, KbnName: "薄い" },
    { Kbn: 2, KbnName: "中間" },
    { Kbn: 3, KbnName: "濃い" },
  ];

  SogoHyokaKbn = [
    { Kbn: 1, KbnName: "改善" },
    { Kbn: 2, KbnName: "改善傾向" },
    { Kbn: 3, KbnName: "維持" },
    { Kbn: 4, KbnName: "維改善が認められない" },
  ];

  GlimHyokaKbn = [
    { Kbn: 1, KbnName: "低栄養非該当" },
    { Kbn: 2, KbnName: "低栄養" },
  ];

  GlimHyokaTeieiyoKbn = [
    { Kbn: 0, KbnName: "低栄養非該当" },
    { Kbn: 1, KbnName: "中等度低栄養" },
    { Kbn: 2, KbnName: "重度低栄養" },
  ];

  HonninIyokuKbn = [
    { Kbn: 1, KbnName: "よい" },
    { Kbn: 2, KbnName: "まあよい" },
    { Kbn: 3, KbnName: "ふつう" },
    { Kbn: 4, KbnName: "あまりよくない" },
    { Kbn: 5, KbnName: "よくない" },
  ];

  ShokujiManzokuKbn = [
    { Kbn: 1, KbnName: "よい" },
    { Kbn: 2, KbnName: "まあよい" },
    { Kbn: 3, KbnName: "ふつう" },
    { Kbn: 4, KbnName: "あまりよくない" },
    { Kbn: 5, KbnName: "よくない" },
  ];

  ShokujiIshikiKbn = [
    { Kbn: 1, KbnName: "大いにある" },
    { Kbn: 2, KbnName: "ややある" },
    { Kbn: 3, KbnName: "ふつう" },
    { Kbn: 4, KbnName: "ややない" },
    { Kbn: 5, KbnName: "全くない" },
  ];

  EiyoCareBunrui = [
    { Kbn: 1, DisplayNumber: "①", KbnName: "栄養補給・食事" },
    { Kbn: 2, DisplayNumber: "②", KbnName: "栄養食事相談" },
    { Kbn: 5, DisplayNumber: "③", KbnName: "多職種による課題の解決など" },
  ];

  GishiSiyoKbn = [
    { Kbn: 1, KbnName: "なし" },
    { Kbn: 2, KbnName: "部分" },
    { Kbn: 3, KbnName: "全部" },
  ];

  IjiKaizenKbn = [
    { Kbn: 0, KbnName: "維持" },
    { Kbn: 1, KbnName: "改善" },
  ];

  KoukouEiseiKanriJisshiHindo = [
    { Kbn: 1, KbnName: "月４回程度" },
    { Kbn: 2, KbnName: "月２回程度" },
    { Kbn: 3, KbnName: "月１回程度" },
    { Kbn: 4, KbnName: "その他" },
  ];

  KoukouKinouHyokaKbn = [
    { Kbn: 1, KbnName: "あり" },
    { Kbn: 0, KbnName: "なし" },
    { Kbn: 2, KbnName: "分からない" },
  ];

  KoukouKinouHyokaKbn2 = [
    { Kbn: 1, KbnName: "できる" },
    { Kbn: 0, KbnName: "できない" },
    { Kbn: 2, KbnName: "分からない" },
  ];

  JokusoHyoka = [
    { Kbn: 1, KbnName: "サービス利用開始時" },
    { Kbn: 2, KbnName: "サービス利用中" },
    { Kbn: 3, KbnName: "サービス終了時" },
  ];

  HaisetuJokyo = [
    { Kbn: 1, KbnName: "なし" },
    { Kbn: 2, KbnName: "夜間のみあり" },
    { Kbn: 3, KbnName: "日中のみあり" },
    { Kbn: 4, KbnName: "終日あり" },
  ];

  JokusoHukasa = [
    { Index: 0, KbnName: "皮膚損傷・発赤なし（d0）", Kbn: "d0" },
    { Index: 1, KbnName: "持続する発赤（d1）", Kbn: "d1" },
    { Index: 2, KbnName: "真皮までの損傷（d2）", Kbn: "d2" },
    { Index: 3, KbnName: "皮下組織までの損傷（D3）", Kbn: "D3" },
    { Index: 4, KbnName: "皮下組織を超える損傷 （D4）", Kbn: "D4" },
    { Index: 5, KbnName: "関節腔、体腔に至る損傷 （D5）", Kbn: "D5" },
    { Index: 6, KbnName: "深部損傷褥瘡（DTI)疑い（DDTI）", Kbn: "DDTI" },
    { Index: 7, KbnName: "壊死組織で覆われ深さの判定が不能（DU）", Kbn: "DU" },
  ];

  JokusoShinshutueki = [
    { Index: 0, KbnName: "なし（e0）", Kbn: "e0" },
    {
      Index: 1,
      KbnName: "少量：毎日のドレッシング交換を要しない（e1）",
      Kbn: "e1",
    },
    {
      Index: 2,
      KbnName: "中等量：1日1回のドレッシング交換を要する（e3）",
      Kbn: "e3",
    },
    {
      Index: 3,
      KbnName: "多量：1日2回以上のドレッシング交換を要する（E6）",
      Kbn: "E6",
    },
  ];

  JokusoOokisa = [
    { Index: 0, KbnName: "皮膚損傷なし（s0）", Kbn: "s0" },
    { Index: 1, KbnName: "4未満（s3）", Kbn: "s3" },
    { Index: 2, KbnName: "4以上16未満（s6）", Kbn: "s6" },
    { Index: 3, KbnName: "16以上36未満（s8）", Kbn: "s8" },
    { Index: 4, KbnName: "36以上64未満（s9）", Kbn: "s9" },
    { Index: 5, KbnName: "64以上100未満（s12）", Kbn: "s12" },
    { Index: 6, KbnName: "100以上（S15）", Kbn: "S15" },
  ];

  JokusoEnshoKansen = [
    { Index: 0, KbnName: "局所の炎症徴候なし（i0）", Kbn: "i0" },
    {
      Index: 1,
      KbnName: "局所の炎症徴候あり(創周囲の発赤・腫脹・熱感・疼痛)（i1）",
      Kbn: "i1",
    },
    {
      Index: 2,
      KbnName:
        "臨界的定着疑い（創面にぬめりがあり、滲出液が多い。肉芽があれば、浮腫性で脆弱など）（I3c）",
      Kbn: "I3c",
    },
    {
      Index: 3,
      KbnName: "局所の明らかな感染徴候あり(炎症徴候、膿、悪臭など) （I3）",
      Kbn: "I3",
    },
    { Index: 4, KbnName: "全身的影響あり(発熱など)（I9）", Kbn: "I9" },
  ];

  JokusoNikugaSoshiki = [
    {
      Index: 0,
      KbnName: "創が治癒した場合、創の浅い場合、深部損傷褥瘡（DTI)疑いの場合",
      Kbn: "g0",
    },
    { Index: 1, KbnName: "良性肉芽が創面の90%以上を占める（g1）", Kbn: "g1" },
    {
      Index: 2,
      KbnName: "良性肉芽が創面の50%以上90%未満を占める（g3）",
      Kbn: "g3",
    },
    {
      Index: 3,
      KbnName: "良性肉芽が創面の10%以上50%未満を占める（G4）",
      Kbn: "G4",
    },
    { Index: 4, KbnName: "良性肉芽が創面の10%未満を占める（G5）", Kbn: "G5" },
    { Index: 5, KbnName: "良性肉芽が全く形成されていない（G6）", Kbn: "G6" },
  ];

  JokusoEshiSoshiki = [
    { Index: 0, KbnName: "壊死組織なし（n0）", Kbn: "n0" },
    { Index: 1, KbnName: "柔らかい壊死組織あり（N3）", Kbn: "N3" },
    { Index: 2, KbnName: "硬く厚い密着した壊死組織あり（N6）", Kbn: "N6" },
  ];

  JokusoPocket = [
    { Index: 0, KbnName: "ポケットなし（p0）", Kbn: "p0" },
    { Index: 1, KbnName: "4未満（P6）", Kbn: "P6" },
    { Index: 2, KbnName: "4以上16未満（P9）", Kbn: "P9" },
    { Index: 3, KbnName: "16以上36未満（P12）", Kbn: "P12" },
    { Index: 4, KbnName: "36以上（P24）", Kbn: "P24" },
  ];

  RishoKbn = [
    { Kbn: 0, KbnName: "なし" },
    { Kbn: 1, KbnName: "10時間以上" },
    { Kbn: 2, KbnName: "6～10時間" },
    { Kbn: 3, KbnName: "3～6時間" },
    { Kbn: 4, KbnName: "3時間未満" },
  ];

  ShituKbn = [
    { Kbn: 1, KbnName: "個室" },
    { Kbn: 2, KbnName: "多床室" },
  ];

  GaishutuKbn = [
    { Kbn: 1, KbnName: "ほぼ毎日" },
    { Kbn: 2, KbnName: "週に2～3回程度" },
    { Kbn: 3, KbnName: "週に1回程度" },
    { Kbn: 4, KbnName: "なし" },
  ];

  ShumiKbn = [
    { Kbn: 1, KbnName: "ほぼ毎日" },
    { Kbn: 2, KbnName: "週に2～3回程度" },
    { Kbn: 3, KbnName: "週に1回程度" },
    { Kbn: 4, KbnName: "なし" },
  ];

  HonninSeikatsuShiKbn = [
    { Kbn: 1, KbnName: "ケアに反映している" },
    { Kbn: 2, KbnName: "ケアへの反映を検討している" },
    { Kbn: 3, KbnName: "反映していない" },
  ];

  KitaiKbn = [
    { Kbn: 3, KbnName: "期待できる" },
    { Kbn: 2, KbnName: "期待できない" },
    { Kbn: 1, KbnName: "不明" },
  ];

  YakuzaiTaniKbn = [
    { Kbn: "01", KbnName: "錠" },
    { Kbn: "02", KbnName: "カプセル" },
    { Kbn: "03", KbnName: "包" },
    { Kbn: "04", KbnName: "ｇ" },
    { Kbn: "05", KbnName: "ｍＬ" },
    { Kbn: "06", KbnName: "瓶" },
    { Kbn: "07", KbnName: "個" },
    { Kbn: "08", KbnName: "丸" },
    { Kbn: "09", KbnName: "袋" },
    { Kbn: "10", KbnName: "筒" },
    { Kbn: "11", KbnName: "シート" },
    { Kbn: "12", KbnName: "セット" },
    { Kbn: "13", KbnName: "カセット" },
  ];

  YakuzaiHenkoStatusKbn = [
    { Kbn: 1, KbnName: "開始" },
    { Kbn: 2, KbnName: "継続" },
    { Kbn: 3, KbnName: "中止" },
  ];

  YakuzaiHenkouRiyuKbn = [
    { Kbn: "01", KbnName: "効果不十分" },
    { Kbn: "02", KbnName: "症状の悪化" },
    { Kbn: "03", KbnName: "傷病の発症" },
    { Kbn: "04", KbnName: "有害事象発現" },
    { Kbn: "05", KbnName: "有害事象発現リスク" },
    { Kbn: "06", KbnName: "非薬物的対応" },
    { Kbn: "07", KbnName: "肝機能・腎機能" },
    { Kbn: "08", KbnName: "同系統薬の重複投与" },
    { Kbn: "09", KbnName: "後発医薬品への切り替え" },
    { Kbn: "10", KbnName: "配合剤への切り替え" },
    { Kbn: "11", KbnName: "服薬アドヒアランスの低下" },
    { Kbn: "12", KbnName: "症状改善" },
    { Kbn: "13", KbnName: "その他" },
  ];

  KazokuJokyoKbn = [
    { Kbn: 1, KbnName: "同居", LifeIndex: 0 },
    { Kbn: 2, KbnName: "独居", LifeIndex: 1 },
  ];

  ServuceShuryoKbn = [
    { Kbn: 1, KbnName: "居宅サービスの利用" },
    { Kbn: 2, KbnName: "介護老人福祉施設入所" },
    { Kbn: 3, KbnName: "介護老人保健施設入所" },
    { Kbn: 4, KbnName: "介護医療院入所" },
    { Kbn: 5, KbnName: "医療機関入院" },
    { Kbn: 6, KbnName: "死亡" },
    { Kbn: 7, KbnName: "介護サービスを利用しなくなった" },
    { Kbn: 8, KbnName: "その他" },
  ];

  VitalityIndexIshi = [
    { Kbn: 2, KbnName: "自分から挨拶する、話し掛ける" },
    { Kbn: 1, KbnName: "挨拶、呼びかけに対して返答や笑顔がみられる" },
    { Kbn: 0, KbnName: "反応がない" },
  ];

  VitalityIndexKisho = [
    { Kbn: 2, KbnName: "いつも定時に起床している" },
    { Kbn: 1, KbnName: "起こさないと起床しないことがある" },
    { Kbn: 0, KbnName: "自分から起床することはない" },
  ];

  VitalityIndexShokuji = [
    { Kbn: 2, KbnName: "自分から進んで食べようとする" },
    { Kbn: 1, KbnName: "促されると食べようとする" },
    { Kbn: 0, KbnName: "食事に関心がない、全く食べようとしない" },
  ];

  VitalityIndexHaisetu = [
    {
      Kbn: 2,
      KbnName: "いつも自ら便意尿意を伝える、あるいは自分で排尿、排便を行う",
    },
    { Kbn: 1, KbnName: "時々、尿意便意を伝える" },
    { Kbn: 0, KbnName: "排せつに全く関心がない" },
  ];

  VitalityIndexRihabiri = [
    { Kbn: 2, KbnName: "自らリハビリに向かう、活動を求める" },
    { Kbn: 1, KbnName: "促されて向かう" },
    { Kbn: 0, KbnName: "拒否、無関心" },
  ];

  KagakutekiHyoka = [
    { Kbn: 1, KbnName: "サービス利用開始時" },
    { Kbn: 2, KbnName: "サービス利用中" },
    { Kbn: 3, KbnName: "サービス終了時" },
  ];

  IcfKbn = [
    { Kbn: 0, KbnName: "すべて" },
    { Kbn: 1, KbnName: "心身" },
    { Kbn: 2, KbnName: "活動" },
    { Kbn: 3, KbnName: "参加" },
  ];

  ShienKbn = [
    { Kbn: "00", KbnName: "未選択" },
    { Kbn: "01", KbnName: "関節可動域訓練" },
    { Kbn: "02", KbnName: "筋力増強訓練" },
    { Kbn: "03", KbnName: "持久力訓練" },
    { Kbn: "04", KbnName: "バランス訓練" },
    { Kbn: "05", KbnName: "上肢機能訓練" },
    { Kbn: "06", KbnName: "疼痛緩和" },
    { Kbn: "07", KbnName: "基本動作訓練" },
    { Kbn: "08", KbnName: "歩行訓練" },
    { Kbn: "09", KbnName: "ADL訓練" },
    { Kbn: "10", KbnName: "IADL訓練" },
    { Kbn: "11", KbnName: "摂食嚥下訓練" },
    { Kbn: "12", KbnName: "言語・聴覚訓練" },
    { Kbn: "13", KbnName: "高次脳機能訓練" },
    { Kbn: "14", KbnName: "認知機能賦活" },
    { Kbn: "15", KbnName: "レクリエーション" },
    { Kbn: "16", KbnName: "支援・調整" },
    { Kbn: "17", KbnName: "その他" },
  ];

  ICF_CODE_SHINSHIN = [
    { Kbn: "b110", KbnName: "意識の維持・改善" },
    { Kbn: "b114", KbnName: "見当識の維持・改善" },
    { Kbn: "b130", KbnName: "意欲の維持・向上" },
    { Kbn: "b134", KbnName: "睡眠の維持・改善" },
    { Kbn: "b710", KbnName: "関節可動域の維持・改善" },
    { Kbn: "b730", KbnName: "筋力の維持・改善" },
    { Kbn: "b280", KbnName: "疼痛の緩和" },
    { Kbn: "b440", KbnName: "呼吸機能の維持・改善" },
    { Kbn: "b455", KbnName: "運動耐容能の維持・改善" },
    { Kbn: "b510", KbnName: "摂食嚥下機能の維持・改善" },
    { Kbn: "b167", KbnName: "言語機能の維持・改善" },
    { Kbn: "b310-399", KbnName: "構音機能の維持・改善" },
    { Kbn: "b140", KbnName: "注意機能の維持・改善" },
    { Kbn: "b144", KbnName: "記憶機能の維持・改善" },
    { Kbn: "s810-899", KbnName: "皮膚機能の維持・改善" },
    { Kbn: "99999999", KbnName: "その他" },
  ];

  ICF_CODE_KATSUDOU = [
    { Kbn: "d410", KbnName: "基本的な姿勢の変換" },
    { Kbn: "d4153", KbnName: "座位の保持" },
    { Kbn: "d4154", KbnName: "立位の保持" },
    { Kbn: "d550", KbnName: "食事" },
    { Kbn: "d420", KbnName: "移乗" },
    { Kbn: "d520", KbnName: "整容" },
    { Kbn: "d530", KbnName: "トイレ動作・排泄管理" },
    { Kbn: "d510", KbnName: "入浴" },
    { Kbn: "d450", KbnName: "歩行" },
    { Kbn: "d4551", KbnName: "階段昇降" },
    { Kbn: "d540", KbnName: "更衣" },
    {
      Kbn: "d465",
      KbnName: "道具（杖、車いす、歩行器、下肢装具）を用いての移動",
    },
    { Kbn: "d430", KbnName: "物の運搬" },
    { Kbn: "d440", KbnName: "細かな手の使用" },
    { Kbn: "d445", KbnName: "手と腕の使用" },
    { Kbn: "d360", KbnName: "コミュニケーションに関わる道具や技法の使用" },
    { Kbn: "d630", KbnName: "料理" },
    { Kbn: "d6400", KbnName: "洗濯" },
    { Kbn: "d6402", KbnName: "掃除" },
    { Kbn: "d6405", KbnName: "ゴミ出し" },
    { Kbn: "d650", KbnName: "家庭用品の管理" },
    { Kbn: "d4602", KbnName: "屋外歩行" },
    { Kbn: "d570", KbnName: "服薬管理、健康管理" },
    { Kbn: "d860", KbnName: "金銭管理" },
    { Kbn: "d620", KbnName: "買い物" },
    { Kbn: "d470", KbnName: "交通機関や手段の利用" },
    { Kbn: "d6505", KbnName: "庭・畑仕事、植物の世話" },
    { Kbn: "d6506", KbnName: "ペットの世話" },
    { Kbn: "d240", KbnName: "ストレスへの対処" },
    { Kbn: "d210", KbnName: "単一の課題の遂行" },
    { Kbn: "d220", KbnName: "複数の課題の遂行" },
    { Kbn: "d230", KbnName: "日課の遂行" },
    { Kbn: "d920", KbnName: "趣味活動，旅行，社交" },
    { Kbn: "99999999", KbnName: "その他" },
  ];

  ICF_CODE_SANKA = [
    { Kbn: "d630", KbnName: "料理" },
    { Kbn: "d6400", KbnName: "洗濯" },
    { Kbn: "d6402", KbnName: "掃除" },
    { Kbn: "d6405", KbnName: "ゴミ出し" },
    { Kbn: "d650", KbnName: "家庭用品の管理" },
    { Kbn: "d4602", KbnName: "屋外歩行" },
    { Kbn: "d570", KbnName: "服薬管理、健康管理" },
    { Kbn: "d860", KbnName: "金銭管理" },
    { Kbn: "d620", KbnName: "買い物" },
    { Kbn: "d470", KbnName: "交通機関や手段の利用" },
    { Kbn: "d6505", KbnName: "庭・畑仕事、植物の世話" },
    { Kbn: "d6506", KbnName: "ペットの世話" },
    { Kbn: "d475", KbnName: "自動車、自転車等の運転" },
    { Kbn: "d240", KbnName: "ストレスへの対処" },
    { Kbn: "d210", KbnName: "単一の課題の遂行" },
    { Kbn: "d220", KbnName: "複数の課題の遂行" },
    { Kbn: "d230", KbnName: "日課の遂行" },
    { Kbn: "d920", KbnName: "趣味活動，旅行，社交" },
    { Kbn: "d660", KbnName: "他者への援助" },
    { Kbn: "d710", KbnName: "社会的交流" },
    { Kbn: "d910", KbnName: "コミュニティへの関与" },
    { Kbn: "d850", KbnName: "仕事" },
    { Kbn: "d855", KbnName: "ボランティア" },
    { Kbn: "99999999", KbnName: "その他" },
  ];

  ChikiKbn = [
    { Kbn: 1, KbnName: "１級地" },
    { Kbn: 6, KbnName: "２級地" },
    { Kbn: 7, KbnName: "３級地" },
    { Kbn: 2, KbnName: "４級地" },
    { Kbn: 3, KbnName: "５級地" },
    { Kbn: 4, KbnName: "６級地" },
    { Kbn: 9, KbnName: "７級地" },
    { Kbn: 5, KbnName: "その他" },
  ];

  ShiftKbn = [
    { Kbn: 1, KbnName: "勤務" },
    { Kbn: 2, KbnName: "公休" },
    { Kbn: 3, KbnName: "有休" },
  ];

  ZaikoKanriKbn = [
    { Kbn: 0, KbnName: "通常" },
    { Kbn: 1, KbnName: "調整" },
    { Kbn: 2, KbnName: "不良、破損" },
    { Kbn: 3, KbnName: "返品" },
    { Kbn: 4, KbnName: "期限切れ" },
    { Kbn: 9, KbnName: "その他" },
  ];

  SyuryoKbn = [
    { Kbn: 1, KbnName: "非該当" },
    { Kbn: 3, KbnName: "医療機関入院" },
    { Kbn: 4, KbnName: "死亡" },
    { Kbn: 5, KbnName: "その他" },
    { Kbn: 6, KbnName: "介護老人福祉施設入所" },
    { Kbn: 7, KbnName: "介護老人保健施設入所 " },
    { Kbn: 8, KbnName: "介護療養型医療施設入院" },
    { Kbn: 9, KbnName: "介護医療院入所" },
  ];

  HonninKbn = [
    { Kbn: 2, KbnName: "本人" },
    { Kbn: 4, KbnName: "６歳" },
    { Kbn: 6, KbnName: "家族" },
  ];

  HutanWariai = [
    { Kbn: 7, KbnName: "７割" },
    { Kbn: 8, KbnName: "８割" },
    { Kbn: 9, KbnName: "９割" },
    { Kbn: 10, KbnName: "１０割" },
  ];

  IryoHokenKbn = [
    { Kbn: 0, KbnName: "国保" },
    { Kbn: 1, KbnName: "社保" },
    { Kbn: 2, KbnName: "公費" },
    { Kbn: 3, KbnName: "後期" },
    { Kbn: 4, KbnName: "退職" },
  ];

  GendoTekiyoKbn = [
    { Kbn: 1, KbnName: "ア" },
    { Kbn: 2, KbnName: "イ" },
    { Kbn: 3, KbnName: "ウ" },
    { Kbn: 4, KbnName: "エ" },
    { Kbn: 5, KbnName: "オ" },
    { Kbn: 11, KbnName: "現役並みⅢ" },
    { Kbn: 12, KbnName: "現役並みⅡ" },
    { Kbn: 13, KbnName: "現役並みⅠ" },
    { Kbn: 14, KbnName: "一般" },
    { Kbn: 15, KbnName: "区分Ⅱ" },
    { Kbn: 16, KbnName: "区分Ⅰ" },
  ];

  ShippeiKbn = [
    { Kbn: 7, KbnName: "別表７" },
    { Kbn: 8, KbnName: "別表８" },
    { Kbn: 0, KbnName: "その他" },
  ];

  GaitoKbn = [
    { Kbn: 1, KbnName: "該当" },
    { Kbn: 0, KbnName: "非該当" },
  ];

  CareKbn = [
    { Kbn: 0, KbnName: "" },
    {
      Kbn: 1,
      KbnName: "緩和ケア",
    },
    {
      Kbn: 2,
      KbnName: "褥瘡ケア",
    },
    {
      Kbn: 3,
      KbnName: "人工肛門",
    },
    {
      Kbn: 4,
      KbnName: "人工膀胱ケア",
    },
  ];

  KihonRyoyoKbn = [
    { Kbn: 0, KbnName: "" },
    { Kbn: 1, KbnName: "基本療養" },
    { Kbn: 2, KbnName: "精神訪問看護" },
    { Kbn: 3, KbnName: "医療観察" },
  ];
}

// // クラスをエクスポート（インスタンス）
export default new MyCategory();
